/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly firstPhotoWebPath: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_item";
};
export type PdpSharedIconBubbleEmail_item$data = PdpSharedIconBubbleEmail_item;
export type PdpSharedIconBubbleEmail_item$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "small"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"small\")"
};
return {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleEmail_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "skus",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    }
  ]
};
})();
(node as any).hash = '46be1527f7f9487b857817aa4c05e5be';
export default node;
